module.exports = __webpack_public_path__ + "static/media/teygja_kalfapressa.c1ccaecc.png";